// src/components/ProyectoSection.js
import React from "react";
import "./ProyectoSection.css";
import img3 from "../assets/Planta.png";

const ProyectoSection = () => {
  return (
    <section className="proyecto-section">
      {/* Title Section */}
      <div className="proyecto-title-container">
        <h2 className="proyecto-title">El Proyecto</h2>
      </div>

      <div className="proyecto-divider"></div>

      {/* Image Section */}
      <div className="proyecto-image-container">
        <img src={img3} alt="El Proyecto" className="proyecto-image" />
      </div>
    </section>
  );
};

export default ProyectoSection;
